
  document.addEventListener('DOMContentLoaded', function() {
    var redirectUrl = 'https://luxurydenim.no/a/loyalty';
    var currentUrl = window.location.href;
    var urlParams = new URLSearchParams(window.location.search);
    var returnParam = urlParams.get('return_url');

    // Check if the URL path includes '/account/login' and 'return_url' is not present
    if (currentUrl.includes('/account/login') && returnParam === null) {
      window.location.href = redirectUrl;
    }
  });

// Hide more than 5 color variants on product page

document.addEventListener("DOMContentLoaded", function () {
  const showMoreLink = document.getElementById("showMoreVariants");
  if (showMoreLink) {
    showMoreLink.addEventListener("click", function () {
      document.querySelectorAll(".hidden-variant").forEach(function (variant) {
        variant.style.display = "block"; // or variant.classList.remove('hidden-variant');
      });
      showMoreLink.style.display = "none"; // Hide the link after expanding
    });
  }
});